

































































































import http from "@/axios/http-common";
import { join, values, mapValues } from "lodash";
import { Vue, Component, Watch, Prop, Ref } from "vue-property-decorator";
import { AxiosError } from "node_modules/axios";
import { appModule } from "@/store/modules/app";
import ObatItemTemplate from "../resep/ObatItemTemplate.vue";
import CardResepItems from "@/components/pemeriksaan/resep-obat/CardResepItems.vue";
import ResepItemInputForm from "../resep/ResepItemInputForm.vue";
import { userModule } from "@/store/modules/user";
import { itemTemplateRanap } from "@/utils/templateResep";

interface PreviewItem {
  nama: string;
  text: Text;
}

@Component({
  components: {
    ObatItemTemplate,
    CardResepItems,
    ResepItemInputForm
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardTemplateResep extends Vue {
  @Prop() items = [];

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  public preview = {
    nama: "",
    text: "",
    items: []
  };
  public showList = true;
  public input = {
    nama: "",
    text: "",
    items: []
  };
  public listTemplate = [];
  public highlighted = null;
  public previewed = null;
  public errItem = {};
  public showAlert = false;
  public saving = false;
  previewItems = [];

  @Prop() showed: boolean;

  @Prop() assign: string;

  @Prop() resepText: Text;

  get stateUser() {
    return userModule.user;
  }

  get templateRanap() {
    return this.stateUser.unit_id >= "50";
  }

  mounted() {
    console.log("on card template resep mounted");
    this.resetPreview();
    this.resetInput();
    this.listTemplate = [];

    console.log("mounted showed", this.showed);

    this.$nextTick(() => {
      console.log("nextick on mounted", this.showed);
    });
  }

  resetPreview() {
    this.preview = {
      nama: "",
      text: "",
      items: []
    };
    this.previewItems = [];

    this.highlighted = null;
    this.previewed = null;
  }

  resetInput() {
    this.input = {
      nama: "",
      text: "",
      items: []
    };
  }

  getListTemplate() {
    http.getData("/template/resep-obat").then(response => {
      this.listTemplate = response.data.data;
    });
  }

  addItem() {
    const items = JSON.parse(JSON.stringify(this.previewItems));

    this.$emit("assign-resep-template", items);
  }

  previewItem(item, idx) {
    this.preview = item;
    this.previewed = idx;
    this.previewItems = itemTemplateRanap(item);
  }

  saveTemplate() {
    if (this.readOnly) return;
    // this.listTemplate.push({ id: 4, ...this.input });
    // this.showList = false;
    if (!this.saving) {
      this.saving = true;
      http
        .postData("/template/resep-obat", this.input)
        .then(() => {
          // this.getListTemplate();
          appModule.sendSuccessNotice("Berhasil menyimpan template resep");
          appModule.closeNoticeWithDelay();

          this.close();
        })
        .catch(errors => {
          console.log(errors);
          this.showErrorAlert(errors);
        })
        .then(() => {
          this.saving = false;
        });
    } else {
      alert("masih ada proses menyimpan sedang berjalan....");
    }
  }

  showErrorAlert(err: AxiosError) {
    const dt = err.response;
    let message = "";
    if (!dt) {
      return;
    }
    if (dt["status"] == 422) {
      message = join(
        values(
          mapValues(err.response.data.errors, function(val) {
            return join(val, "; ");
          })
        ),
        "; "
      );
    } else {
      message = `ERR ${err.response.status}: ${err.response.data.message}`;
    }

    appModule.sendErrorAlert(message);
  }

  close() {
    this.$emit("close-modal");
    this.items = [];
    this.resetPreview();
    this.resetInput();
    this.listTemplate = [];
  }

  @Watch("showList")
  changedShowList(show: boolean) {
    if (!show) {
      this.input.nama = "";
      this.input.text = "";
      this.input.items = [];
    }
  }

  @Watch("showed")
  changedShowed(status: boolean) {
    if (status) {
      if (this.assign == "list") {
        this.getListTemplate();
      } else if (this.assign == "input") {
        this.input.text = String(this.resepText);
        this.input.items = this.items;
      }
    } else {
      this.listTemplate = [];
      this.resetPreview();
      this.resetInput();
      this.highlighted = null;
    }
  }

  @Watch("assign")
  changedAssign(val: string) {
    if (val === "list") {
      this.showList = true;
    } else if (val === "input") {
      this.showList = false;
      this.$nextTick(function() {});
    }
  }
  public rules = {
    required: value => !!value || "Kolom ini harus diisi"
  };
  public entries = [];
  public isLoading = false;
  public model = null;
  public search = null;

  public _timerId;

  @Ref() readonly searchBox!: HTMLInputElement;

  selectObat(val) {
    this.search = null;
    this.entries = [];
    this.addObatSingle(val);

    this.$nextTick(() => {
      this.searchBox.blur();
    });
  }
  // items: Array<ObatSingle>;
  addObatSingle(obat) {
    if (obat) {
      this.input.items.push({
        obat_nama: obat.nama,
        qty: null,
        qty_unit: obat.satuan,
        obat_id: obat.id,
        ap_tambahan: null,
        ap_template_id: null,
        ap_template_nama: null,
        r: null
      });
    } else {
      this.input.items.push({
        obat_nama: "",
        qty: null,
        qty_unit: "",
        obat_id: null,
        ap_tambahan: null,
        ap_template_id: null,
        ap_template_nama: null,
        r: null
      });
    }
  }

  @Watch("search")
  changedSearch() {
    this.entries = [];

    clearTimeout(this._timerId);

    this._timerId = setTimeout(() => {
      if (this.search === null || this.search.length < 3) return;

      this.isLoading = true;

      http
        .getDataParam("/referensi/obat/search", {
          params: { term: this.search }
        })
        .then(res => {
          this.entries = res.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }, 500);
  }
  // @Watch("searchString")
  // searched() {
  //   this.listAturanPakai = [];
  //   clearTimeout(this._timerId);
  //   this._timerId = setTimeout(() => {
  //     if (this.searchString === null || this.searchString.length < 2) return;
  //     this.searchAturanPakai(this.searchString);
  //   }, 500);
  // }
  // searchAturanPakai(termSearch) {
  //   http
  //     .getDataParam(`/aturan-pakai/search`, {
  //       params: { term: termSearch },
  //     })
  //     .then((res) => {
  //       this.listAturanPakai = res.data;
  //     })
  //     .finally();
  // }
  // changeAturanPakai(val, i) {
  //   if (val) {
  //     console.log("aturan pakai", i, ":", val);
  //     // alert(this.item.obat_nama);
  //     this.items[i].ap_template_id = val.id;
  //     this.items[i].ap_template_nama = val.nama;
  //     this.items[i].aturan_pakai.id = val.id;
  //     this.items[i].aturan_pakai.nama = val.nama;
  //     // this.items.ap_template_nama = this.item.aturan_pakai.nama;
  //     // this.items.ap_template_id = this.item.aturan_pakai.id;
  //     // this.$nextTick(() => {
  //     //   this.jml.focus();
  //     // });
  //   }
  // }
  itemColor(index) {
    return index % 2 === 0 ? "grey lighten-3" : "";
  }

  removeItem(idx) {
    this.input.items.splice(idx, 1);
  }

  updateFormItem(val) {
    console.log("updateFormItem", val);
    this.input.items = val;
  }
}
